import { Injectable } from '@angular/core'
import { ILoyaltyCardDeleteResult } from 'app/passengers/passengers.interfaces'
import { Observable } from 'rxjs'
import { StatelessHttpService } from 'app/shared/stateless-http.service'

@Injectable()
export class LoyaltyNectarService {

    constructor(private statelessHttpService: StatelessHttpService) { }

    removeCardFromUserProfile(provider: number): Observable<ILoyaltyCardDeleteResult> {
        return this.statelessHttpService.delete<ILoyaltyCardDeleteResult>(`loyalty/${provider}`)
    }

    // // 00012369019
    // getValidateValidator(provider: string, preCardNumber: string): AsyncValidatorFn {
    //     return (c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    //         return new Promise((res, rej) => {
    //             if (!c.value) {
    //                 return res(null)
    //             }
    //             const search: URLSearchParams = new URLSearchParams()
    //             search.set('provider', provider)
    //             search.set('cardNumber', `${preCardNumber}${c.value}`)
    //             this.statelessHttpService.get(true, 'loyalty-valid, { search }).map(d => d.json() as IValidationResult).subscribe(x => res(x.valid ? null : { checkCardNumber: true }))
    //         })
    //     }
    // }
}
